'use strict';

const ProgressStatusCalculator = require('../../models/progress-status-calculator'),
	ProgressModel = require('../../models/progress-model'),
	ProgressIconPersister = require('../../models/progress-icon-persister'),
	IconEditorController = require('../../models/icon-editor-controller'),
	mmWidgets = require('../../widgets/mm-widgets');

require('../../widgets/context-disabler-widget');
require('../../widgets/progress-tools-widget');
require('../../widgets/progress-status-menu-widget');
require('../../widgets/progress-config-selector-widget');
require('../../widgets/progress-projections-widget');
require('../../widgets/progress-calc-widget');
require('../../widgets/progress-filter-property-toggle-widget');
require('../../widgets/progress-config-editor-widget');


module.exports = function progressStart(mapModel, imagePicker, domImageDimensionCalculator, colorPickerModel, imageAuthenticator, resourceDecompressor) {
	const statusCalculator = new ProgressStatusCalculator(),
		progressModel = new ProgressModel(mapModel, statusCalculator),
		progressIconPersister = new ProgressIconPersister(),
		progressIconEditorController = new IconEditorController(progressIconPersister, imagePicker, domImageDimensionCalculator, imageAuthenticator);


	mmWidgets('[data-mm-progress-context]').contextDisablerWidget(progressModel, 'progressContext', 'data-mm-progress-context');
	mmWidgets('#progressTools').progressToolsWidget(progressModel);
	mmWidgets('[data-mm-role~="progress-status-menu"]').progressStatusMenuWidget(progressModel, resourceDecompressor);
	mmWidgets('[data-mm-role~="progress-config-selector"]').progressConfigSelectorWidget(progressModel);
	mmWidgets('[data-mm-role~="progress-projection-selector"]').progressProjectionsWidget(progressModel);
	mmWidgets('[data-mm-role~="progress-calc"]').progressCalcWidget(progressModel);

	mmWidgets('[data-mm-role~="progress-toggle-property"]').progressFilterPropertyToggleWidget(progressModel);


	mmWidgets('#progress-status-config').progressConfigEditorWidget(progressModel, colorPickerModel, progressIconPersister, progressIconEditorController, resourceDecompressor);

	return {
		progressModel: progressModel,
		progressIconPersister: progressIconPersister,
		progressIconEditorController: progressIconEditorController

	};

};
